var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    fill: "current",
    viewBox: "0 0 49.162 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_518",
    "data-name": "\\uADF8\\uB8F9 518",
    transform: "translate(733 2790)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_234",
    "data-name": "\\uC0AC\\uAC01\\uD615 234",
    d: "M10,2a8.009,8.009,0,0,0-8,8V27.5a8.009,8.009,0,0,0,8,8H39.162a8.009,8.009,0,0,0,8-8V10a8.009,8.009,0,0,0-8-8H10m0-2H39.162a10,10,0,0,1,10,10V27.5a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(-733 -2790)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_233",
    "data-name": "\\uC0AC\\uAC01\\uD615 233",
    width: 35.162,
    height: 25.5,
    rx: 5,
    transform: "translate(-726 -2784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_235",
    "data-name": "\\uC0AC\\uAC01\\uD615 235",
    d: "M6,2A4,4,0,0,0,2,6V8H38V6a4,4,0,0,0-4-4H6M6,0H34a6,6,0,0,1,6,6v4H0V6A6,6,0,0,1,6,0Z",
    transform: "translate(-728 -2748)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/pos.94af3254ba42094717ad984d9ba8167e.svg";
export { ForwardRef as ReactComponent };